import { render, staticRenderFns } from "./MonitoringMipeStudents.vue?vue&type=template&id=022fe29d&scoped=true&"
import script from "./MonitoringMipeStudents.vue?vue&type=script&lang=js&"
export * from "./MonitoringMipeStudents.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringMipeStudents.vue?vue&type=style&index=0&id=022fe29d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022fe29d",
  null
  
)

export default component.exports